<div
  class="usage-report-widget"
  [attr.data-cy]="attributeDataCy"
  (click)="showUsageReport()"
>
  <div>
    <h4 class="title">
      {{ 'platformCartridgeWidget.usageReport.displayName' | transloco }}
      <span class="package-name" [hidden]="isLoading">
        - {{ serviceVariantName }}</span
      >
    </h4>

    <div class="flex-row-centered content" [class.hidden]="isLoading">
      <div class="flex-col-centered information">
        <div class="total-number">{{ total$ | async }}</div>
        <div class="total-text">
          <markant-icon class="icon" icon="m_chart-graph"></markant-icon>
          <span class="info">
            {{
              'usage.report.details.total'
                | transloco: { servicePackage: servicePackageName }
            }}
          </span>
        </div>
      </div>

      <div class="flex-col-centered chart">
        <canvas
          baseChart
          [class.hidden]="(total$ | async) === 0"
          [type]="chart.type"
          [data]="chart.data"
          [options]="chart.options"
          [legend]="false"
        >
        </canvas>

        <div *ngIf="(total$ | async) === 0" class="flex-row-centered">
          <span>{{ 'common.noResults' | transloco }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="loading" *ngIf="isLoading">
    <markant-spinner modal="false" colorScheme="primary"></markant-spinner>
  </div>
</div>
